/**
 * Pagination directive for Edit functionality
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.
  directive('lmPagination', [function () {
    return {
      restrict: 'E',
      scope: {
        offset: '=?',
        limit: '=?',
        nextFn: '&',
        prevFn: '&',
        isStart: '=?',
        isEnd: '=?',
        maxLength: '=?'
      },
      link: function (scope, element, attrs, ngModel) {
        scope.page = parseInt(scope.offset / scope.limit, 10) + 1;
        if (scope.maxLength) {
          scope.maxPage = parseInt(scope.maxLength / scope.limit, 10) + 1;
        }

        scope.offsetWatcher = scope.$watchCollection('offset', function (newValue) {
          scope.page = parseInt(newValue / scope.limit, 10) + 1;
        });

        scope.maxLengthtWatcher = scope.$watchCollection('maxLength', function (newValue) {
          scope.maxPage = parseInt(newValue / scope.limit, 10) + 1;
        });

        scope.$on('$destroy', function () {
          scope.offsetWatcher();
          scope.maxLengthtWatcher();
        });
      },
      templateUrl: 'lm-pagination/pagination.tpl.html'
    };
  }]);
